
import { Transaction } from './Transaction'

export class PagedTransactionList {
    
    
    pageNo;
    isLastPage;
    
    index;
    
    transactions;
    
    //Construct from the backend Json Response
    constructor(json) {
        if (json) {
            this.isLastPage = json.last; 
            this.pageNo = json.pageNo; 
            this.index = json.index;
            
            if (json.items)
                this.transactions = json.items.map(t => new Transaction(t));
            else
                this.transactions = [];
            
        }  
    } 
    
    isFirst = () => {
        return this.pageNo === 0;
    }
    
    isLast = () => {
        return this.isLastPage;
    }
    
}